import { render, staticRenderFns } from "./RecommendActivityIndex.vue?vue&type=template&id=eb444932&scoped=true"
import script from "./RecommendActivityIndex.vue?vue&type=script&lang=js"
export * from "./RecommendActivityIndex.vue?vue&type=script&lang=js"
import style0 from "./RecommendActivityIndex.vue?vue&type=style&index=0&id=eb444932&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb444932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb444932')) {
      api.createRecord('eb444932', component.options)
    } else {
      api.reload('eb444932', component.options)
    }
    module.hot.accept("./RecommendActivityIndex.vue?vue&type=template&id=eb444932&scoped=true", function () {
      api.rerender('eb444932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/recommend_activity/RecommendActivityIndex.vue"
export default component.exports